import React from "react";
import styled from "styled-components";
import { AvField } from "availity-reactstrap-validation";
import { InputGroup } from "reactstrap";
import CustomSelect from "./CustomSelect";
import PropTypes from "prop-types";

const SelectWithInput = ({ select_name, inputOptions = {}, options = [], defaultValue, isLoading = false, onChange = function() {} }) => {

  return (
    <>
      <SelectWithInputStyled className="mb-3">
        <CustomSelect
          classNamePrefix="select2-selection"
          // style={{ maxWidth: "90px" }}
          options={options}
          defaultValue={defaultValue}
          name={select_name}
          isLoading={isLoading}
          onChange={onChange}
        />
        <AvField
          {...inputOptions}
          className="form-control"
          // id=""
          // onChange={(e, v, d) => console.log({ e, v, d })}
        />
      </SelectWithInputStyled>
    </>
  );
};

SelectWithInput.propTypes = {
  select_name: PropTypes.any,
  name: PropTypes.string,
  options: PropTypes.any,
  defaultValue: PropTypes.any,
  inputType: PropTypes.string,
  required: PropTypes.bool,
  inputOptions: PropTypes.any,
  isLoading: PropTypes.bool,
  onChange: PropTypes.func,
};

const SelectWithInputStyled = styled(InputGroup)`
  .form-group {
    flex: 1
  }

  .select2-selection__control { 
    height: 36px;
    min-height: 20px;
    width: 48px;
    margin-right: 1em;

    .select2-selection__indicators {
      display: none;
    }
  }

  .select2-selection__menu {
    width: calc(100% + 20px) !important;
    top: initial !important;
  }
`;

export default (SelectWithInput);
